import { BulkEditPill } from './BulkEditPill';
import styled from '@emotion/styled';
import { useParentItemsFromSelectedSubItems } from '../../state/selection.state';

export const BulkEditPillBar = () => {
  const items = useParentItemsFromSelectedSubItems(false);

  return (
    <StyledPillBarContainer>
      {items.map((item) => (
        <BulkEditPill item={item} lastItem={items.length === 1} key={item.id} />
      ))}
    </StyledPillBarContainer>
  );
};

const StyledPillBarContainer = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding: 0.5rem 0;
`;
